import renderSeatInformationHeader from './renderSeatInformationHeader';
import renderPriceTypeDetails from './renderPriceTypeDetails';
import renderPriceTypeListHeading, { PRICE_TYPE_LIST_HEADING_ID } from './renderPriceTypeListHeading';
import renderOrderLevelFeeDisclaimer, { OrderLevelFeeDisclaimerConfig } from './renderOrderLevelFeeDisclaimer';
import SeatAriaLabelRenderer from './SeatAriaLabelRenderer';
import type SyosSeat from '../SyosSeat';
import { ExtendedPriceTypeData } from '../api/types';
import { IPriceTypeSelectionHelper } from '../priceTypeSelectionHelpers/types';
import { ISyosLabels } from '../labels/types';

function renderPriceTypeList(labels: ISyosLabels, seat: SyosSeat, priceTypes: ExtendedPriceTypeData[], isAvailable: boolean, config: OrderLevelFeeDisclaimerConfig) {
  if (isAvailable) {
    return `${renderOrderLevelFeeDisclaimer(config)}
    ${renderPriceTypeListHeading(labels.seatInfoPriceTypeListHeading)}
    <ul class="list-unstyled tn-syos-seat-info__price-type-list" aria-labelledby="${PRICE_TYPE_LIST_HEADING_ID}">
      ${priceTypes.map(renderPriceTypeListItem).join('')}
    </ul>`;
  }

  const unavailableLabel = SeatAriaLabelRenderer.getUnavailableSeatLabel(seat);

  return renderPriceTypeListHeading(unavailableLabel);
}

function renderPriceTypeListItem(priceType: ExtendedPriceTypeData) {
  return `<li class="tn-syos-seat-info__price-type-list-item tn-syos-seat-info__price-type-list-item--divided">
    <div class="tn-syos-seat-info__price-type">
      ${renderPriceTypeDetails(priceType)}
    </div>
  </li>`;
}

function render(labels: ISyosLabels, seat: SyosSeat, priceTypeSelectionHelper: IPriceTypeSelectionHelper, config: OrderLevelFeeDisclaimerConfig) {
  if (!priceTypeSelectionHelper.canMakeAnotherSelection) {
    return renderSeatInformationHeader(seat);
  }

  const allSeatPriceTypes = seat.getPriceTypes();

  const priceTypes = priceTypeSelectionHelper.getFilteredPriceTypes(allSeatPriceTypes);

  const isAvailable = seat.getIsAvailable() && priceTypes.length > 0;

  return renderSeatInformationHeader(seat)
    + renderPriceTypeList(labels, seat, priceTypes, isAvailable, config);
}

export default {
  render,
};
